import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Breadcrumb, Button } from "antd";
import WalletLayout from "../../wallet-layout";
import { _adr } from "../../../../address";
import { Content } from "antd/es/layout/layout";
import { useLocation } from "react-router-dom";
import { complexDigitToman, convertToJalaliWithTime, formatTime } from "../../../../tools/tools";
import OprationResult from "../../../auxiliary/opration/opration";
import { useSelector } from "react-redux";

const WalletFinal = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const { _currentUser } = useSelector((state) => state?.another);

  return (
    <WalletLayout>
      <div className="g-hold-title-of-page">
        <Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("wallet.withdrawal") }]} />
        <div className="title-page">
          <h3>{t("wallet.withdrawal")}</h3>
          <p></p>
        </div>
      </div>
      <div className="g-layout-content">
        <Content className="g-layout-main wa-container">
          <div className="g-format-page">
            <div className="g-body-format-page">
              <div className="final-container">
                <div className="row-content-form">
                  <div className="content-area">
                    <OprationResult
                      isSucess={true}
                      list={[
                        {
                          label: "تاریخ و ساعت",
                          value: (
                            <span dir="ltr">
                              {convertToJalaliWithTime(new Date().toISOString())} - {formatTime(new Date())}
                            </span>
                          ),
                        },
                        {
                          label: "نوع برداشت",
                          value: "برداشت نقدی از اعتبار",
                        },
                        {
                          label: "مبلغ",
                          value: (
                            <>
                              <span dir="ltr">{complexDigitToman(location?.state?.amount)}</span> تومان
                            </>
                          ),
                        },
                        {
                          label: "شماره حساب",
                          value: <span dir="ltr">{_currentUser?.bankaccountnumber}</span>,
                        },
                        {
                          label: "کد پیگیری",
                          value: <span dir="ltr">{location?.state?.followupcode}</span>,
                        },
                      ]}
                      messageForSuccess=" درخواست شما بعد از بررسی و تایید اپراتور به حساب اعلام شده واریز خواهد شد."
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="g-footer-format-page">
              <div className="holder-button">
                <Button className="btn-normal btn-print" onClick={() => window.print()} type="default" icon={<i className="icon-print"></i>}>
                  چاپ فاکتور
                </Button>
              </div>
            </div>
          </div>
        </Content>
      </div>
    </WalletLayout>
  );
};

export default WalletFinal;
